// @ts-nocheck

import { filter, every, sample } from 'lodash';
import memoize from 'memoize-state';

import { getLang } from '../../../i18n/l10n';
import { BetslipTypes, BetslipStatus } from '../../../types/history';
import getBetslipNotableCase from '../../../utils/getBetslipNotableCase';
import sentences from '../constants/sentencesPerCase';

import { getBetslipFromProps, getEnhancedOutcomes } from './common';

export const mainAreaSelector = memoize((state, props) => {
  const betslip = getBetslipFromProps(state, props);
  const {
    status,
    type,
    betAmount,
    globalOdds,
    winningsAmount,
    winningsBonus,
    possibleWinnings,
    possibleBonus,
    details,
    freebet,
  } = betslip;

  let winnings = 0;
  if (winningsAmount !== null && winningsAmount !== undefined) {
    winnings = winningsAmount + (winningsBonus || 0);
  } else if (possibleWinnings) {
    winnings = possibleWinnings + (possibleBonus || 0);
  }

  const enhancedOutcomes = getEnhancedOutcomes(state, details);
  const allBetbuilder = every(enhancedOutcomes, 'isBetbuilder');
  const lostOutcomes = filter(enhancedOutcomes, { outcomeHasOccured: false });
  const oneLost = lostOutcomes && lostOutcomes.length === 1;
  const allLost = every(enhancedOutcomes, { outcomeHasOccured: false });

  const betslipNotableCase = getBetslipNotableCase(
    status,
    type,
    globalOdds,
    betAmount,
    winningsAmount,
    allBetbuilder,
    oneLost,
    allLost,
  );

  const isSystem = type === BetslipTypes.SYSTEM;
  const hasBonus = !!((possibleBonus && possibleBonus > 0) || (winningsBonus && winningsBonus > 0));

  return {
    sentence: sample(sentences[getLang().toUpperCase()][betslipNotableCase]),
    freebet,
    betAmount,
    globalOdds,
    winnings,
    isCancelled: status === BetslipStatus.CANCELLED,
    isLost: status === BetslipStatus.SETTLED && winningsAmount === 0,
    hasBonus,
    isSystem,
  };
});
